import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import { ThoughtBlock, ToolCallVisualizer, StepChangeIndicator } from './index'

const useStyles = makeStyles((theme) => ({
  explainabilitySection: {
    // Events rendered inline with timeline
    marginBottom: 'var(--margin-xl)',
    '& > *:first-child': {
      marginTop: 0 // Remove top margin from first event
    }
  }
}))

function ExplainabilitySection ({ events = [], visible = true }) {
  const classes = useStyles()

  if (!visible || !events || events.length === 0) {
    return null
  }

  const renderEvent = (event) => {
    switch (event.type) {
      case 'thought':
        return <ThoughtBlock key={event.id} {...event} />
      case 'toolCall':
        return <ToolCallVisualizer key={event.id} {...event} />
      case 'stepChange':
        return <StepChangeIndicator key={event.id} {...event} />
      default:
        return null
    }
  }

  return (
    <FadeIn className={classes.explainabilitySection}>
      <FlexColumn
        className='gap-xs radius-md px-4 pt-1 pb-5'
        style={{
          border: 'var(--dai-border1)',
          backgroundColor: 'var(--dai-color-surface4)'
        }}
      >
        {events.map(renderEvent)}
      </FlexColumn>
    </FadeIn>
  )
}

ExplainabilitySection.propTypes = {
  events: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(['thought', 'toolCall', 'stepChange']).isRequired,
    id: PropTypes.string.isRequired,
    sequence: PropTypes.number.isRequired,
    timestamp: PropTypes.string.isRequired
  })),
  visible: PropTypes.bool
}

export default ExplainabilitySection
